/**
 * Ordering for the guided signing walk (DOMA 13272162455).
 *
 * After a signature is adopted the signer is carried to the next required field
 * so they can read that section before signing it. The walk must follow the
 * document top-to-bottom — page first, then vertical position, then horizontal —
 * rather than the order fields were dropped on in the editor (a signature added
 * earlier but sitting lower must still be visited after one that sits higher).
 *
 * Kept dependency-free (no react-pdf / component imports) so it is unit-testable
 * on its own.
 */
export const byReadingOrder = (a, b) =>
  (a.page - b.page) || (a.y_pct - b.y_pct) || (a.x_pct - b.x_pct);
